import React from 'react'
import Wingedvoyage from './Wingedvoyage/Wingedvoyage'

const WingedVoyage = () => {
  return (
    <Wingedvoyage />
  )
}

export default WingedVoyage